import { useEffect } from "react";
export const useTitle = (title: string | any, description: string | any = null) => {
  useEffect(() => {
    document.title = title;
    document
      .querySelector(`meta[name="description"]`)
      ?.setAttribute("content", description || process.env.REACT_APP_META_DES);
  });
};
